<template>
  <div class="contact">
    <div class="contact-content">
      <MeetUs/>
      <HireUs/>
    </div>
    <GmapMap
      :center="activeCenter"
      :zoom="zoom"
      :options="activeOptions"
      map-type-id="roadmap"
      class="g-map-bg"
    >
      <GmapMarker
        :key="index"
        v-for="(m, index) in markers"
        :position="m.position"
        :clickable="true"
        :draggable="true"
        @click="center=m.position"
      />
    </GmapMap>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import MeetUs from '@/components/contact/MeetUs.vue';
import HireUs from '@/components/contact/HireUs.vue';

export default {
  name: 'contact',
  components: {
    MeetUs,
    HireUs,
  },
  data() {
    return {
      center: {
        xs: { lat: 50.723812, lng: -1.841147 },
        sm: { lat: 50.723812, lng: -1.845147 },
        md: { lat: 50.735812, lng: -1.825147 },
        lg: { lat: 50.735812, lng: -1.825147 },
      },
      zoom: 15,
      markers: [{
        position: { lat: 50.727612, lng: -1.837147 },
      }],
      options: {
        xs: {
          zoomControl: false,
          mapTypeControl: false,
          streetViewControl: false,
        },
      },
    };
  },
  computed: {
    ...mapState('viewport', ['viewport']),
    activeOptions() {
      const { options, viewport } = this;
      return options[viewport.name] || options.xs;
    },
    activeCenter() {
      const { center, viewport } = this;
      return center[viewport.name] || center.xs;
    },
  },
};
</script>

<style lang="stylus" scoped>
  @import '../styles/variables';
  .contact{
    position: relative;
    z-index: 610;

    &:before{
      content: '';
      position: absolute;
      top: 0;
      background-image: linear-gradient(0deg, rgba(252,252,252,0.00) 0%, #F7F7F7 75%);
      height: 200px;
      width: 100%;
      z-index: -2;
    }
  }

  .g-map-bg{
      background-size: cover;
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -3;
      opacity: 0.55;
  }

  @media(min-width: $breakpoint-sm-min){

    .contact{
      &:before{
        height: 535px;
      }
    }

    .contact-content{
      padding-bottom: 145px;
    }
  }

  @media(min-width: $breakpoint-md-min) {
    .contact{
      &:before{
        height: 668px;
      }
      &:after{
        content: '';
        position: absolute;
        bottom: 0;
        background-image: linear-gradient(270deg, rgba(252,252,252,0.00) 13%, #F7F7F7 88%);
        height: 100%;
        width: 700px;
        z-index: -2;
      }
    }

    .contact-content{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 1120px;
      margin: 0 auto;
      padding-top: 210px;
      padding-bottom: 260px;
    }
  }

  @media(min-width: $breakpoint-lg-min) {
    .contact-content{
      max-width: 1365px;
      margin: 0 auto;
      padding-top: 245px;
      padding-bottom: 240px;
    }
  }
</style>
